import { TimeInput } from '../TimeInput';
import { DurationInput } from '../DurationInput';
import { FormSection } from '../ui/FormSection';
import type { EventFormErrors } from './types';

export interface EventScheduleFieldsProps {
  startDate: string;
  onStartDateChange: (value: string) => void;
  startTime: { hours: number; minutes: number } | undefined;
  onStartTimeChange: (value: { hours: number; minutes: number } | undefined) => void;
  duration: number | undefined;
  onDurationChange: (value: number | undefined) => void;
  errors: EventFormErrors;
  touched: Record<string, boolean>;
  onBlur: (field: string) => void;
  isSubmitting: boolean;
}

export const EventScheduleFields = ({
  startDate,
  onStartDateChange,
  startTime,
  onStartTimeChange,
  duration,
  onDurationChange,
  errors,
  touched,
  onBlur,
  isSubmitting,
}: EventScheduleFieldsProps) => (
  <FormSection title="Date and Time">
    {/* Start Date */}
    <div>
      <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 mb-1">
        Start Date <span className="text-red-500">*</span>
      </label>
      <input
        id="startDate"
        type="date"
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
        onBlur={() => onBlur('startDate')}
        disabled={isSubmitting}
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          touched.startDate && errors.startDate ? 'border-red-500' : 'border-gray-300'
        } ${isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''}`}
      />
      {touched.startDate && errors.startDate && (
        <p className="mt-1 text-sm text-red-600">{errors.startDate}</p>
      )}
    </div>

    {/* Start Time */}
    <TimeInput
      value={startTime}
      onChange={onStartTimeChange}
      label="Start Time"
      error={touched.startTime ? errors.startTime : undefined}
      disabled={isSubmitting}
    />

    {/* Duration */}
    {startTime && (
      <DurationInput
        value={duration}
        onChange={onDurationChange}
        label="Duration"
        error={touched.duration ? errors.duration : undefined}
        disabled={isSubmitting}
      />
    )}
  </FormSection>
);
